import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import AlertBanner from '../../components/common/AlertBanner';
import BlockWrapper from '../../components/help/BlocksWrapper';
import StatusBar from '../../components/help/StatusBar';
import {getInitialCmsPageSharedValues, PageData, useCmsData, useMiscStore} from 'epic-ue-shared';
import {useEpicStatus} from '../../shared/status.hooks';
import Error404 from '../error/Error404';

const cmsUrlPattern = '/customer-service';

interface CustomerServicePageData extends PageData {
    customerServiceMain?: any;
    customerServiceOther?: any;
    title?: string;
    mainDesc?: string;
    otherTitle?: string;
    otherDesc?: string;
    alertMsg?: string;
    sections: any;
}

const CustomerService = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} =
        useCmsData<CustomerServicePageData>(cmsUrlPattern);
    const miscStore = useMiscStore();
    const epicStatusUrl = miscStore.epicStatusUrl;
    const {epicStatus, loading} = useEpicStatus();

    if (cmsLoading) {
        return <LoadIndicator />;
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const csMain = pageData.customerServiceMain || {};
    const mainBlocks = csMain.blocks || [];

    const csOther = pageData.customerServiceOther || {};
    const otherBlocks = csOther.blocks || [];

    const mainDesc = pageData.mainDesc || '';
    const otherTitle = pageData.otherTitle || '';
    const otherDesc = pageData.otherDesc || '';
    const alertMsg = pageData.alertMsg || '';

    let mainDescElem;
    if (mainDesc && mainDesc.length) {
        mainDescElem = <p className="description text-center">{mainDesc}</p>;
    }

    let otherTitleElem;
    if (otherTitle && otherTitle.length) {
        otherTitleElem = <div className="h1">{otherTitle}</div>;
    }

    let otherDescElem;
    if (otherDesc && otherDesc.length) {
        otherDescElem = <p className="description text-center">{otherDesc}</p>;
    }

    return (
        <div className="customer-service">
            <StatusBar statusData={epicStatus} url={epicStatusUrl} fetching={loading} />
            {alertMsg ? <AlertBanner message={alertMsg} /> : null}
            <div className="container">
                <div className="row">
                    {getHelmetForMetaTags(pageData)}
                    <h1>{pageData.title || ''}</h1>
                    {mainDescElem}

                    <BlockWrapper blocks={mainBlocks} useNarrowImage={false} />

                    {otherTitleElem}
                    {otherDescElem}

                    <BlockWrapper blocks={otherBlocks} useNarrowImage={false} />
                </div>
            </div>
        </div>
    );
};

CustomerService.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default CustomerService;
